import React, { useState } from "react";
import { Grid } from "@material-ui/core";

import BreadcrumbAndTitle from "@components/BreadcrumbAndTitle";
import { BreadcrumbChild } from "@components/BreadcrumbCustom";

import ROUTES from "@config/routes";

import NotificationFormikContainer from "../resource/form/NotificationFormikContainer";
import { NotificationFormModeEnum } from "../resource/form/hook/interface";

const OnlyNotificationView: React.FC = () => {
  const [refId, setRefId] = useState<string>();

  const breadcrumbData: BreadcrumbChild[] = [
    { label: "Início", link: ROUTES.ADMIN_ROUTES.HOME },
    { label: "Notificações", link: ROUTES.ADMIN_ROUTES.NOTIFICATIONS.ROOT },
    { label: refId ? `Visualizar #${refId}` : "Visualizar" },
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <BreadcrumbAndTitle
          breadcrumbData={breadcrumbData}
          title={refId ? `Visualizar Notificação #${refId}` : "Notificação"}
        />
      </Grid>

      <Grid item xs={12}>
        <NotificationFormikContainer
          mode={NotificationFormModeEnum.VIEW}
          onRefIdLoaded={setRefId}
        />
      </Grid>
    </Grid>
  );
};

export default OnlyNotificationView;
